export default __webpack_public_path__ + "static/media/engine-brake.a1dc0214.svg";